/* Danella v4 · Seoul Blush · small behaviors: header shadow, reveal on scroll, rail arrows, one-tap "add the routine" */
(function () {
  'use strict';
  var d = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) { if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn); else fn(); }

  ready(function () {
    /* header gets a soft shadow once the page scrolls */
    var h = d.querySelector('.sb-header');
    if (h) {
      var on = function () { h.classList.toggle('is-stuck', window.scrollY > 8); };
      on();
      window.addEventListener('scroll', on, { passive: true });
    }

    /* reveal on scroll */
    var els = [].slice.call(d.querySelectorAll('.sb-reveal'));
    if (els.length) {
      if (!reduce && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
          });
        }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
        els.forEach(function (el) { io.observe(el); });
      } else {
        els.forEach(function (el) { el.classList.add('is-in'); });
      }
    }

    /* rails: previous / next buttons scroll the track */
    d.querySelectorAll('[data-sb-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-sb-track]');
      if (!track) return;
      var prev = rail.querySelector('[data-sb-prev]');
      var next = rail.querySelector('[data-sb-next]');
      var step = function () { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : 280; };
      var sync = function () {
        if (prev) prev.disabled = track.scrollLeft < 8;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });

    /* one-tap routine: add every step to the bag, show what the spend-and-save ladder would take off */
    d.querySelectorAll('[data-sb-routine]').forEach(function (box) {
      var btn = box.querySelector('[data-sb-addall]');
      var save = box.querySelector('[data-sb-save]');
      var total = Number(box.getAttribute('data-total') || 0);
      var V = window.DanellaV4 || {};
      var tiers = (V.spendSave && V.spendSave.tiers) || [{ min: 50, pct: 10 }, { min: 90, pct: 15 }, { min: 110, pct: 20 }];
      var pct = 0;
      tiers.forEach(function (t) { if (total >= t.min * 100 && t.pct > pct) pct = t.pct; });
      var fmt = function (c) { var v = c / 100; return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); };
      if (save && pct) {
        var off = Math.round(total * pct / 100);
        /* total row: cross out the full price, show the discounted price bigger */
        var totRow = box.querySelector('.sb-routine__total');
        var totB = totRow && totRow.querySelector('b');
        if (totB) {
          totB.innerHTML = '<s>' + fmt(total) + '</s><span>' + fmt(total - off) + '</span>';
          totRow.classList.add('has-save');
        }
        save.innerHTML = 'Spend-and-save takes <b>' + pct + '% off</b> in your bag. You save <b>' + fmt(off) + '</b>.';
        save.hidden = false;
      }
      if (!btn) return;
      btn.addEventListener('click', function () {
        var ids = (btn.getAttribute('data-ids') || '').split(',').filter(Boolean);
        if (!ids.length) return;
        var label = btn.textContent;
        btn.disabled = true; btn.textContent = 'Adding…';
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
        }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function () {
            btn.textContent = 'Added';
            return fetch(root + 'cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            d.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.classList.toggle('is-empty', cart.item_count === 0); });
            if (window.DanellaV4 && window.DanellaV4.openCart) window.DanellaV4.openCart();
            setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1600);
          })
          .catch(function () {
            btn.disabled = false; btn.textContent = 'Something went wrong. Try again';
            setTimeout(function () { btn.textContent = label; }, 2400);
          });
      });
    });
  });
})();